// src/utils/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollToTop(el) {
  if (!el) return;
  // Intenta API moderna
  if (typeof el.scrollTo === 'function') {
    try {
      el.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return;
    } catch (_) {
      // alguns navegadors no tenen 'instant'; prova sense opcions
      try { el.scrollTo(0, 0); return; } catch (_) {}
    }
  }
  // Fallback
  try { el.scrollTop = 0; } catch (_) {}
}

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Espera al següent frame perquè el nou DOM estigui pintat
    requestAnimationFrame(() => {
      // I un segon frame si hi ha layouts que calculen al primer
      requestAnimationFrame(() => {
        const candidates = [
          window,
          document.scrollingElement,      // html en la majoria de navegadors
          document.documentElement,       // <html>
          document.body,                  // <body>
          document.querySelector('.main-content'),
          document.querySelector('.flex-container'),
          document.getElementById('root'),
        ];

        candidates.forEach(scrollToTop);
      });
    });
  // si canvies de pàgina o de query, volem anar amunt igualment
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;